import {
  calendar_default
} from "./chunk-5RJ3MFP4.js";

// src/modules/calendar/calendar.tsx
import { jsx } from "react/jsx-runtime";
var mCalendar = ({
  _id,
  className = "",
  content,
  labels,
  sequence
}) => {
  return /* @__PURE__ */ jsx(
    "section",
    {
      className,
      "data-module-sequence": sequence,
      "data-module-type": "mCalendar",
      id: _id,
      children: /* @__PURE__ */ jsx(calendar_default, { id: `${_id}_calendar`, labels, ...content })
    }
  );
};
var calendar_default2 = mCalendar;

export {
  calendar_default2 as calendar_default
};
